import { store } from '~/Store'
import {
  setRelationLabels,
  setDisabledRelations,
  setDisabledTypes,
  setIdPrefix,
  setIdType,
  setNamespacesEnabled,
  setNamespaces,
  setMemberKeys,
  setNameKeys,
} from 'Actions/explore'
import { DisabledRelations, DisabledTypes, IdFormat, Namespaces, MemberKeys, NameKeys, RelationLabels } from 'Model'
import { getProjectData } from './WeaverUtils'

class ConfigService

  constructor: ->
    @items = [
      {
        getter: -> (await DisabledRelations.load()).list()
        defaults: []
        setter: setDisabledRelations
        includeHardcoded: (data) ->
          if getProjectData().disabledRelations?
            [data..., getProjectData().disabledRelations...]
          else
            data
      },
      {
        getter: -> (await DisabledTypes.load()).list()
        defaults: []
        setter: setDisabledTypes
        includeHardcoded: (data) ->
          if getProjectData().disabledTypes?
            [data..., getProjectData().disabledTypes...]
          else
            data
      },
      {
        getter: -> (await RelationLabels.load()).get('value')
        defaults: {}
        setter: setRelationLabels
      },
      {
        getter: -> (await MemberKeys.load()).list()
        defaults: ['type']
        setter: setMemberKeys
      },
      {
        getter: -> (await NameKeys.load()).list()
        defaults: ['name']
        setter: setNameKeys
      },
      {
        getter: -> (await Namespaces.load()).map()
        defaults: {}
        setter: setNamespaces
      },
      {
        getter: -> (await Namespaces.load()).enabled()
        defaults: true
        setter: setNamespacesEnabled
      },
      {
        getter: -> (await IdFormat.load()).getPrefix()
        defaults: ''
        setter: setIdPrefix
      },
      {
        getter: -> (await IdFormat.load()).getIdType()
        defaults: 'uuid'
        setter: setIdType
      }
    ]

  readProjectConfig: ->
    @items.map((item) ->
      try
        if item.includeHardcoded?
          configItem = item.includeHardcoded(await item.getter())
        else
          configItem = await item.getter()
      catch
        configItem = item.defaults
      store.dispatch(item.setter(configItem))
    )

export default new ConfigService()
